export class CasePermissions {
    public static readonly draft: string = 'cases:draft:cases';
    public static readonly open: string = 'cases:open:cases';
    public static readonly write: string = 'cases:write:cases';
    public static readonly read: string = 'cases:read:cases';
    public static readonly close: string = 'cases:close:cases';
    public static readonly reopen: string = 'cases:reopen:cases';
    public static readonly transfer: string = 'cases:transfer:cases';
    public static readonly search: string = 'cases:search:cases';
}

export class CaseTypesPermissions {
    public static readonly readAreasOfLaw: string = 'cases:read:areas-of-law';
    public static readonly writeAreasOfLaw: string = 'cases:write:areas-of-law';
    public static readonly writePrescriptionDate: string =
        'cases:write:prescription-dates';
    public static readonly readCourts: string = 'cases:read:courts';
    public static readonly writeCourts: string = 'cases:write:courts';
    public static readonly readQuickChecks: string = 'cases:read:quick-checks';
    public static readonly writeQuickChecks: string =
        'cases:write:quick-checks';
    public static readonly readClosingReasons: string =
        'cases:read:closing-reasons';
    public static readonly writeClosingReasons: string =
        'cases:write:closing-reasons';
    public static readonly writeTaskTypes: string = 'cases:write:task-types';
    public static readonly readTypes: string = 'cases:read:types';
    public static readonly readHolidays: string = 'cases:read:holidays';
}

export class CaseCourtDatePermissions {
    public static readonly read: string = 'cases:read:court-dates';
    public static readonly write: string = 'cases:write:court-dates';
    public static readonly delete: string = 'cases:delete:court-dates';
}

export class CaseNotePermissions {
    public static readonly read: string = 'cases:read:notes';
    public static readonly write: string = 'cases:write:notes';
}

export class CaseTaskPermissions {
    public static readonly read: string = 'cases:read:tasks';
    public static readonly write: string = 'cases:write:tasks';
    public static readonly complete: string = 'cases:complete:tasks';
}

export class CaseHistoryPermissions {
    public static readonly search: string = 'casehistory:search:casehistory';
}

export class CaseDocumentPermissions {
    public static readonly upload: string = 'casedocuments:upload:documents';
    public static readonly read: string = 'casedocuments:read:documents';
    public static readonly download: string =
        'casedocuments:download:documents';
    public static readonly delete: string = 'casedocuments:delete:documents';
    public static readonly remove: string = 'casedocuments:remove:documents';
    public static readonly restore: string = 'casedocuments:restore:documents';
    public static readonly view: string = 'casedocuments:view:documents';
}

export class CaseRequiredDocumentsPermissons {
    public static readonly read: string =
        'casedocuments:read:required-documents';
    public static readonly write: string =
        'casedocuments:write:required-documents';
    public static readonly delete: string =
        'casedocuments:delete:required-documents';
}

export class CaseDocumentTypesPermissions {
    public static readonly readDocumentTypes: string =
        'casedocuments:read:document-types';
    public static readonly writeDocumentTypes: string =
        'casedocuments:write:document-types';

    public static readonly readSuggestedDocuments: string =
        'casedocuments:read:suggested-documents';
    public static readonly writeSuggestedDocuments: string =
        'casedocuments:write:suggested-documents';
}

export class CaseContactPermissions {
    public static readonly write: string = 'cases:write:contacts';
    public static readonly read: string = 'cases:read:contacts';
}

export class CaseCommunicationPermissions {
    public static readonly read: string =
        'communicationsmanager:read:communications';
    public static readonly write: string =
        'communicationsmanager:write:manual-communications';
    public static readonly writeClosedCaseCommunication: string =
        'communicationsmanager:write:manual-communications-closed-cases';
}
